const IOS_APP_UA_TOKEN = "SetbackApp/iOS";

export const APP_STORE_URL = "https://apps.apple.com/us/app/setback-pitch/id6765941654";
export const SETBACK_DEEP_LINK = "setback://";

export type BrowserGateVariant = "app" | "ios-browser" | "download";

/** True when the page is loaded inside the native Setback iOS WKWebView. */
export function isSetbackIOSApp(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent.includes(IOS_APP_UA_TOKEN);
}

/** Safari/Chrome on iPhone or iPad, but not the native in-app web view. */
export function isIOSMobileBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/** Local Vite dev server — skip the browser gate for testing. */
export function shouldBypassBrowserGate(): boolean {
  return import.meta.env.DEV;
}

export function getBrowserGateVariant(): BrowserGateVariant {
  if (shouldBypassBrowserGate() || isSetbackIOSApp()) return "app";
  if (isIOSMobileBrowser()) return "ios-browser";
  return "download";
}
